export async function getPlanQuery(lyr, objid) {
  var query = lyr.createQuery();
  query.where = "OBJECTID=" + objid;
  return lyr.queryFeatures(query);
}
